import React from "react";
import { ArrowRight, Sparkles, ShieldCheck, Hammer } from "lucide-react";

export default function Hero() {
  return (
    <section id="top" className="relative overflow-hidden" data-testid="hero-section">
      <div className="absolute inset-0 grain-bg pointer-events-none" />
      <div className="container-page relative pt-16 pb-20 md:pt-24 md:pb-28">
        <div className="grid lg:grid-cols-12 gap-10 items-center">
          <div className="lg:col-span-7 animate-fade-up">
            <span className="eyebrow">Impresa Edile · Genova · dal 1984</span>
            <h1 className="heading-display text-4xl sm:text-5xl lg:text-[72px] leading-[1.02] mt-5">
              Costruiamo, ristrutturiamo
              <br />
              <span className="text-brand-terracotta">la tua casa</span>{" "}
              <span className="italic font-medium">in Liguria.</span>
            </h1>
            <p className="mt-6 text-base md:text-lg text-brand-mute max-w-2xl leading-relaxed">
              Oltre 40 anni di tradizione artigiana italiana incontrano l'intelligenza
              artificiale: chiedi al nostro chatbot, visualizza la ristrutturazione della
              tua stanza in pochi secondi e scegli con fiducia.
            </p>

            <div className="mt-8 flex flex-wrap gap-3">
              <a href="#contatti" className="btn-primary" data-testid="hero-cta-preventivo">
                Richiedi un preventivo gratuito <ArrowRight className="h-4 w-4" />
              </a>
              <a href="#visualizzatore" className="btn-secondary" data-testid="hero-cta-visualizer">
                <Sparkles className="h-4 w-4" /> Prova il Visualizzatore AI
              </a>
            </div>

            <dl className="mt-12 grid grid-cols-3 gap-6 max-w-xl">
              {[
                { k: "40+", v: "Anni di esperienza" },
                { k: "1000+", v: "Cantieri completati" },
                { k: "100%", v: "Liguria coperta" },
              ].map((s) => (
                <div key={s.v}>
                  <dt className="heading-display text-3xl md:text-4xl text-brand-ink">{s.k}</dt>
                  <dd className="text-xs uppercase tracking-wider text-brand-mute mt-1">{s.v}</dd>
                </div>
              ))}
            </dl>
          </div>

          <div className="lg:col-span-5 relative">
            <div className="relative aspect-[4/5] rounded-3xl overflow-hidden card-tactile">
              <img
                src="https://images.unsplash.com/photo-1755316388093-faff473ffdfb?crop=entropy&cs=srgb&fm=jpg&q=85&w=1200"
                alt="Cucina ristrutturata"
                className="absolute inset-0 w-full h-full object-cover"
              />
              <div className="absolute bottom-4 left-4 right-4 bg-white/90 backdrop-blur rounded-xl p-4 flex items-center gap-3">
                <div className="h-10 w-10 rounded-full bg-brand-sage/20 flex items-center justify-center">
                  <ShieldCheck className="h-5 w-5 text-brand-sage" />
                </div>
                <div className="text-sm">
                  <div className="font-semibold text-brand-ink">Soluzioni chiavi in mano</div>
                  <div className="text-brand-mute">Tempi rispettati, materiali certificati.</div>
                </div>
              </div>
            </div>
            <div className="hidden md:flex absolute -left-6 top-10 card-tactile px-4 py-3 items-center gap-3 rotate-[-4deg]">
              <Hammer className="h-5 w-5 text-brand-terracotta" />
              <div className="text-sm font-medium">Lavorazione artigiana</div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
